/* =========================================================
   Why Switch — reveal + staggered rows + total count-up
   ========================================================= */

(function () {
  'use strict';

  function initWhySwitch(root) {
    if (!root || root.dataset.whyInit === 'true') return;
    root.dataset.whyInit = 'true';

    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- Reveal on scroll ----------
    const revealEls = root.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -50px 0px',
        }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }

    if (reducedMotion) return;

    // ---------- Animate total values (count-up) ----------
    const totals = root.querySelectorAll('.why__total strong');
    totals.forEach((totalEl) => {
      const raw = totalEl.textContent.trim();
      // Match e.g. "R 9,600" or "R399"
      const match = raw.match(/^(\D*)([\d,]+(?:\.\d+)?)(\D*)$/);
      if (!match) return;

      const prefix = match[1];
      const numStr = match[2].replace(/,/g, '');
      const target = parseFloat(numStr);
      const suffix = match[3];
      if (isNaN(target)) return;

      totalEl.dataset.final = raw;
      totalEl.textContent = `${prefix}0${suffix}`;

      const countIO = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateNumber(totalEl, target, prefix, suffix, 1300);
              countIO.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );
      countIO.observe(totalEl);
    });

    // ---------- Staggered row reveal inside each card ----------
    const cards = root.querySelectorAll('.why__col');
    cards.forEach((card) => {
      const rows = card.querySelectorAll('.why__list li');
      rows.forEach((row, i) => {
        row.style.opacity = '0';
        row.style.transform = 'translateX(-8px)';
        row.style.transition = `opacity 0.5s ease ${i * 60}ms, transform 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${i * 60}ms`;
      });

      const cardIO = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              rows.forEach((row) => {
                row.style.opacity = '1';
                row.style.transform = 'translateX(0)';
              });
              cardIO.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.25 }
      );
      cardIO.observe(card);
    });
  }

  function animateNumber(el, target, prefix, suffix, duration) {
    const start = performance.now();

    function format(value) {
      const hasDecimal = target % 1 !== 0;
      const rounded = hasDecimal ? value.toFixed(2) : Math.round(value);
      // Add comma separators for thousands
      const formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${prefix}${formatted}${suffix}`;
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);
      el.textContent = format(target * eased);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = el.dataset.final;
      }
    }

    requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('.why[data-section-id]').forEach(initWhySwitch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.why[data-section-id]');
    if (root) initWhySwitch(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.why[data-section-id]');
    if (root) root.dataset.whyInit = '';
  });
})();
